import { apiClient } from '../api/client';

export interface PublicServer {
  id: string;
  name: string;
  gameType: string;
  status: string;
  imageUrl: string | null;
}

export const serverService = {
  async listByStore(storeId: string): Promise<PublicServer[]> {
    const data = await apiClient.get<{ servers: PublicServer[] }>(
      `/public/stores/${storeId}/servers`
    );
    return data.servers ?? [];
  },
};
